"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTerminalNodeOptionsFilter = void 0;
const graphql_1 = require("../../../../../__generated__/graphql");
const buildTerminalNodeOptionsFilter = (query) => {
    var _a;
    const normalizedQuery = (_a = query === null || query === void 0 ? void 0 : query.trim()) !== null && _a !== void 0 ? _a : '';
    if (!normalizedQuery) {
        return { terminalNodesOnly: true };
    }
    return {
        terminalNodesOnly: true,
        title: {
            contains: normalizedQuery,
            mode: graphql_1.StringFilterMode.Insensitive,
        },
    };
};
exports.buildTerminalNodeOptionsFilter = buildTerminalNodeOptionsFilter;
